import React from 'react';
import { View } from 'react-native';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import PropTypes from 'prop-types';

import style from './style';

const Row = ({ title, titleStyle, value, valueStyle, rowStyle }) => (
  <View style={[style.row, rowStyle]}>
    <VFText style={titleStyle} i18nKey={title} />
    <VFText style={valueStyle} i18nKey={value} />
  </View>
);

Row.propTypes = {
  title: PropTypes.string,
  titleStyle: PropTypes.object,
  value: PropTypes.string,
  valueStyle: PropTypes.object,
  rowStyle: PropTypes.object,
};

export default Row;
